import React from "react";
import { cn } from "@/lib/utils";
import coralPin from "@/assets/berastays-logo-pin.png";

interface CoralPinProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src" | "alt"> {
  className?: string;
  alt?: string;
}

/**
 * Coral House Pin — substitui o ícone genérico Sparkles em toda a plataforma.
 * Mantém API compatível com lucide (aceita className de tamanho como w-4 h-4).
 */
export const CoralPin: React.FC<CoralPinProps> = ({ className, alt = "BeraStays", ...rest }) => {
  return (
    <img
      src={coralPin}
      alt={alt}
      loading="lazy"
      decoding="async"
      {...rest}
      className={cn("inline-block object-contain align-[-0.125em] shrink-0", className)}
    />
  );
};

export default CoralPin;
